import React, { Component } from 'react';
import EventCard from "../components/eventCard"
import bookSale2 from "../gallery/gallery47.png";
const bookSaleInfo= "There's another Book Sale coming soon!  3,000+ books to peruse. Old and New!  Something for everyone, every age, action packed to cook book.";

const eventCard3Mobile = (
<EventCard
    eventImage={bookSale2}
    title={"Board Meeting"}
    information={
      "Held every second Thursday of the Month at Union Gap Library And Community Center"
    }
    date={"Every Second Thursday Of the Month"}
    width={"85%"}
    height={"auto"}
    startTime={"3:30pm"}
    endTime={"5:30pm"}
    location={"Union Gap Library And Community Center"}
  ></EventCard>
  );
class eventsMobile3 extends Component {
    
    render() {
        return (
            <div>
            <div className="eventsParent" >
            <div className="eventsContainer">
        <h1 className="eventsHeading">Events / Fundraisers</h1>
       <div className="eventCardContainerMobile">{eventCard3Mobile} </div>
   </div>
 </div>
       </div>
        );
    }
}

export default eventsMobile3;